import { LitElement, html, css } from 'lit-element';
import { FBP } from '@furo/fbp';
import { i18n } from '@furo/framework';
import '@furo/form/src/furo-catalog.js';
import '../../project-components/textbaustein-reference-search.js';

/**
 * `sz-detail-form`
 * Describe your element
 *
 * @summary shortdescription
 * @customElement
 * @demo demo/sz-detail-form.html
 * @appliesMixin FBP
 */

class SzDetailForm extends FBP(LitElement) {
  constructor() {
    super();
    this._textbausteinActive = false;
  }

  /**
   * Collection der KST
   * @param {}
   */
  kstCollectionIn(det) {
    this.injectedKstCollection = det;
    this._FBPTriggerWire('--kstCollectionInjected', det);
  }

  /**
   * Collection der Objekte
   * @param {}
   */
  objectCollectionIn(det) {
    this._FBPTriggerWire('--objectCollectionInjected', det);
  }

  /**
   * Startet die progressbar vom form
   */
  startActivity() {
    this._FBPTriggerWire('--startActivity', null);
  }

  /**
   * Stopt die progressbar vom form
   */
  stopActivity() {
    this._FBPTriggerWire('--stopActivity', null);
  }

  bindData(d) {
    this.fields = d;
    d.ulid_kostenstelle.addEventListener('field-value-changed', () => {
      this._FBPTriggerWire('--kstChanged', d.ulid_kostenstelle._value);
    });

    this._FBPTriggerWire('--data', d);

    d.textbaustein_active.addEventListener('field-value-changed', e => {
      this._textbausteinActive = e.detail._value;
      this.requestUpdate();
    });
  }

  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();
    //   this._FBPTraceWires();
    this._checkKST = e => {
      this._showKM = false;
      if (this.injectedKstCollection) {
        const currentItem = this.injectedKstCollection.entities.find(value => value.data.id === e);

        if (currentItem != null && currentItem.data.rapport_show_km_l) {
          this._showKM = true;
        }
      }
      this.requestUpdate();
    };

    this._FBPAddWireHook('--kstChanged', this._checkKST);

    this._FBPAddWireHook('--clearKmFieldValue', () => {
      this.fields.km._value = null;
    });
  }

  /**
   *
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return css`
      :host {
        display: block;
        position: relative;
      }

      .obenRechts furo-data-text-input {
        width: 70px;
      }

      .obenRechts furo-data-number-input {
        width: 80px;
        margin-left: 12px;
      }

      .obenRechts {
        position: absolute;
        right: 0px;
        top: 0;
      }
    `;
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <furo-form
        header-text="${i18n.t('s-zeiterfassung_main_titel')}"
        ƒ-start-activity="--startActivity"
        ƒ-stop-activity="--stopActivity"
      >
        <div class="obenRechts">
          <furo-data-number-input
            readonly
            condensed
            float
            disabled
            ƒ-bind-data="--data(*.faktor)"
          ></furo-data-number-input>
          <furo-data-number-input
            readonly
            condensed
            float
            disabled
            ƒ-bind-data="--data(*.dauer)"
          ></furo-data-number-input>
        </div>

        <furo-form-layouter two breakpoint-big="810,405" breakpoint-small="380">
          <furo-data-date-input ƒ-bind-data="--data(*.tag)"></furo-data-date-input>

          <furo-form-layouter two breakpoint-big="400,300" breakpoint-small="200">
            <furo-data-time-input
              ƒ-focus="--data"
              ƒ-bind-data="--data(*.zeit_von)"
            ></furo-data-time-input>
            <furo-data-time-input ƒ-bind-data="--data(*.zeit_bis)"></furo-data-time-input>
          </furo-form-layouter>

          <furo-data-collection-dropdown
            full
            ƒ-inject-entities="--objectCollectionInjected(*.entities)"
            ƒ-bind-data="--data(*.ulid_supportcaseobject)"
          ></furo-data-collection-dropdown>

          <furo-form-layouter two full>
            <furo-data-collection-dropdown
              flex
              ƒ-inject-entities="--kstCollectionInjected(*.entities)"
              ƒ-bind-data="--data(*.ulid_kostenstelle)"
              display-field="text"
            ></furo-data-collection-dropdown>

            <furo-data-number-input
              flex
              ?hidden=${!this._showKM}
              ƒ-bind-data="--data(*.km)"
              value="0"
              trailing-icon="clear"
              @-trailing-icon-clicked="--clearKmFieldValue"
              ƒ-focus="--clearKmFieldValue"
            ></furo-data-number-input>
          </furo-form-layouter>

          <textbaustein-reference-search
            ?hidden=${!this._textbausteinActive}
            ƒ-bind-text="--data(*.text)"
            min-term-length="2"
            @-item-selected="--refSearchItemSelected"
            ƒ-set-filter="--artikelfilter"
            full
          ></textbaustein-reference-search>

          <furo-data-textarea-input
            full
            ƒ-bind-data="--data(*.text)"
            rows="7"
          ></furo-data-textarea-input>
        </furo-form-layouter>
      </furo-form>
    `;
  }
}

window.customElements.define('sz-detail-form', SzDetailForm);
